<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(".upsell-sec label[title^='Size']").each(function(){
    var text = $(this).text();
    text = text.replace("Size", "");
    $(this).text(text);
})